import gql from "graphql-tag";

export const ADD_FEEDBACK = gql`
  mutation addFeddback(
    $user: String!
    $email: String!
    $value: String!
    $comment: String
    $date: String!
    $status: String!
    $project: String!
  ) {
    addFeddback(
      user: $user
      email: $email
      value: $value
      comment: $comment
      date: $date
      status: $status
      project: $project
    ) {
      id
    }
  }
`;
